import Swiper from 'swiper/bundle';

/**
  * Creates a Swiper instance
  * @param {string} selector - Swiper container selector
  * @param {string} paginationSelector - Pagination element selector
  */
const createSwiper = (selector, paginationSelector) => {
  const el = document.querySelector(selector);
  if (!el) return null;
  return new Swiper(selector, {
    slidesPerView: 'auto',
    mousewheel: { forceToAxis: true },
    pagination: { el: paginationSelector, clickable: false, type: 'bullets' },
  });
};

export const collectionCarousel = () => {
  const SWIPERS_DATA = [
    {
      classes: '.collection-carousel-swiper',
      pagination: '.swiper-scrollbar-collection',
    },
  ];

  SWIPERS_DATA.forEach(({ classes, pagination }) => {
    createSwiper(classes, pagination);
  });
};